import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Company } from '../entity/company.entity';
import { Repository } from 'typeorm';
import { CompanyModel } from './models/company.model';
import { CompanyIdRequest, CompanyResponse, ErrorResponse } from '@schemax-whatsapp/shared-models';
import { ModuleService } from '../module/module.service';
import { BiMessageService } from '../bi-message/bi-message.service';

@Injectable()
export class CompanyService {

    constructor(
        @InjectRepository(Company) private companyRepo: Repository<Company>, 
        @Inject(forwardRef(() => ModuleService)) private moduleService: ModuleService,
        @Inject(forwardRef(() => BiMessageService)) private biMessageService: BiMessageService,
    ) {
         
    }

    /**
     * 
     * @param companyReq 
     * @returns 
     */
    async createCompany(companyReq: CompanyModel): Promise<CompanyResponse> {
        const companyRec = await this.getCompanyByCompanyCode(companyReq.companyCode);
        if(companyRec) {
            throw new ErrorResponse(0, 'Company code already exist');
        }
        const companyEnt = this.convertCompanyModelToEntity(companyReq.companyCode, companyReq.companyName, companyReq.address, companyReq.username);
        const savedEnt = await this.companyRepo.save(companyEnt);
        const companyModel = this.convertCompanyEntityToModel(savedEnt);
        return new CompanyResponse(true, 0, 'Company saved successfully', [companyModel]);
    }


    /**
     * 
     * @param companyReq 
     * @returns 
     */
    async editCompany(companyReq: CompanyModel): Promise<CompanyResponse> {
        const companyRec = await this.getCompanyByCompanyCode(companyReq.companyCode);
        if(!companyRec) {
            throw new ErrorResponse(0, 'Company code does not exist');
        }
        const companyEnt = this.convertCompanyModelToEntity(companyReq.companyCode, companyReq.companyName, companyReq.address, companyReq.username);
        companyEnt.companyId = companyReq.companyId;
        const savedEnt = await this.companyRepo.save(companyEnt);
        const companyModel = this.convertCompanyEntityToModel(savedEnt);
        return new CompanyResponse(true, 0, 'Company edited successfully', [companyModel]);
    }

    /**
     * 
     * @returns 
     */
    async getAllCompanies(): Promise<CompanyResponse> {
        const companyModels: CompanyModel[] = [];
        const companies = await this.companyRepo.find({ where: {isActive: true}});
        for(const company of companies) {
            const companyModel = this.convertCompanyEntityToModel(company);
            companyModels.push(companyModel);
        }
        return new CompanyResponse(true, 0, 'Companies retrieved successfully', companyModels);
    }

    /**
     * 
     * @param companyCodeReq 
     */
    async deleteCompany(companyIdReq: CompanyIdRequest): Promise<CompanyResponse> {
        const companyRec = await this.getCompanyByCompanyId(companyIdReq.companyId);
        if(!companyRec) {
            throw new ErrorResponse(0, 'Company code does not exist');
        }
        await this.companyRepo.delete({ companyId: companyIdReq.companyId });
        return new CompanyResponse(true, 0, 'Company deleted successfully'); 
    }

    /**
     * 
     * @param companyCode 
     * @returns 
     */
    async getCompanyByCompanyCode(companyCode: string): Promise<Company> {
        return await this.companyRepo.findOne({ where: {companyCode: companyCode, isActive: true}});
    }

    /**
     * 
     * @param companyCode 
     * @returns 
     */
    async getCompanyByCompanyId(companyId: number): Promise<Company> {
        return await this.companyRepo.findOne({ where: {companyId: companyId, isActive: true}});
    }

    /**
     * 
     * @param companyCode 
     * @param companyName 
     * @param address 
     * @param username 
     * @returns 
     */
    convertCompanyModelToEntity(companyCode: string, companyName: string, address: string, username: string): Company {
        const company = new Company();
        company.companyCode = companyCode;
        company.address = address;
        company.companyName = companyName;
        company.createdUser = username;
        return company;
    }

    /**
     * 
     * @param companyEnt 
     * @returns 
     */
    convertCompanyEntityToModel(companyEnt: Company): CompanyModel {
        const companyModel = new CompanyModel(companyEnt.companyId, companyEnt.companyCode, companyEnt.companyName, companyEnt.address, companyEnt.createdUser);
        return companyModel
    }


     /**
     * 
     * @param companyId 
     */
    async checkIfCompanyExist(companyId: number): Promise<boolean> {
        const companyRec = await this.companyRepo.findOne({ where: {companyId: companyId}});
        if(!companyRec) {
            throw new ErrorResponse(0, 'Company does not exist');
        }
        return true;
    }

}
